import { generatePath } from 'react-router-dom';
import queryString from 'query-string';

import { ROUTE } from '@app/constants';

import { useQueryParams } from './useQueryParams';

export const useInstanceDetailsRoutePath = () => {
  const searchState = useQueryParams();

  return {
    getInstanceDetailsRoutePath(
      id: string,
      searchStateOverrides = {}
    ): {
      pathname: string;
      search: string;
    } {
      return {
        pathname: generatePath(ROUTE.instanceDetails, { id }),
        search: queryString.stringify({
          ...searchState,
          ...searchStateOverrides,
        }),
      };
    },
    checkIsInstanceDetailsRoute(pathname: string) {
      return pathname.startsWith(ROUTE.instanceDetails.split('/:id')[0]);
    },
  };
};
